import { Map } from 'immutable';
import * as actionTypes from 'constants/actionTypes';

const init = Map({ success: false, error: '' });

export default function autoSaveReducer(state = init, action) {
    switch (action.type) {
    case actionTypes.AUTO_SAVE_SUCCESS:
        return state.set('success', true).set('error', '');
    case actionTypes.AUTO_SAVE_FAIL:
        return state.set('success', false).set('error', action.errorData);
    default:
        return state;
    }
}
